import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NbAuthResult, NbEmailPassAuthProvider } from '@nebular/auth';

/**
 * Nebular's email/password provider, adjusted for Firebase Auth's REST API.
 *
 * Login, register, password reset and token refresh go straight to Firebase; the
 * endpoints and response keys are set in core.module.ts. This class holds the two
 * behaviour differences that config alone cannot express.
 *
 * Until 2026 this lived as a hand edit inside node_modules/@nebular/auth, which was
 * lost when node_modules stopped being committed. Keeping it here means any fresh
 * install builds a working login.
 */
@Injectable()
export class FirebaseEmailPassAuthProvider extends NbEmailPassAuthProvider {

  constructor(http: HttpClient, route: ActivatedRoute) {
    super(http, route);
  }

  /**
   * Firebase's getOobConfirmationCode endpoint sends a reset email only when told
   * which kind of email it is.
   */
  requestPassword(data?: any): Observable<NbAuthResult> {
    return super.requestPassword(Object.assign({}, data, { requestType: 'PASSWORD_RESET' }));
  }

  /**
   * Firebase has no logout endpoint, so the request Nebular makes always fails.
   * Logging out only needs the local token cleared, so treat it as a success.
   */
  logout(): Observable<NbAuthResult> {
    return super.logout().pipe(
      map(result => result.isSuccess() ? result : new NbAuthResult(
        true,
        result.getResponse(),
        this.getConfigValue('logout.redirect.success'),
        result.getErrors(),
      )),
    );
  }
}
